import { render, staticRenderFns } from "./UsageChangeSummary.vue?vue&type=template&id=256a4dff&scoped=true&"
import script from "./UsageChangeSummary.vue?vue&type=script&lang=js&"
export * from "./UsageChangeSummary.vue?vue&type=script&lang=js&"
import style0 from "./UsageChangeSummary.vue?vue&type=style&index=0&id=256a4dff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a4dff",
  null
  
)

export default component.exports